import {createContext} from 'react';

export interface IPortalContextProps {
    visibility: boolean;
    name: string;
    onClose?: () => void;
}

export const PortalContext = createContext<IPortalContextProps>({} as IPortalContextProps);
